import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { forgotApi, verifyOtpApi } from "../../services/auth/Auth";
import toast from "react-hot-toast";
import useButtonLoader from "../../hooks/UseButtonLoader";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import OTPInput from "react-otp-input";
import {
  catchMessage,
  elseMessage,
  successMessage,
} from "../../comman/Message";

const OtpVerify = () => {
  const email = localStorage.getItem("email" || "");
  const [buttonref, buttonLoader] = useButtonLoader("resend link", "#28B17B");

  const [resendLink, setResendLink] = useState(false);
  const [countdown, setCountdown] = useState(45); // Initial countdown value in seconds
  const navigate = useNavigate();
  const [operationInProgress, setOperationInProgress] = useState(false);
  const [otp, setOtp] = useState("");
  const { token } = useParams();

  const verifyOtp = async () => {
    try {
      const res = await verifyOtpApi({ email: email, otp: otp });
      if (res?.data?.status === 200) {
        successMessage(res);
        navigate(`/reset-password`);
        localStorage.setItem("otp", otp);
      } else {
        elseMessage(res);
      }
    } catch (error) {
      catchMessage(error);
    }
  };
  const sendEmail = async () => {
    try {
      const res = await forgotApi({ email: email || "" });
      if (res.data.status === 200) {
        successMessage(res);
        setResendLink(true);
      } else {
        elseMessage(res);
      }
    } catch (error) {
      catchMessage(error);
    }
  };

  const onSubmit = () => {
    if (!operationInProgress && !resendLink) {
      setOperationInProgress(true);
      sendEmail();
      const timer = setInterval(() => {
        setCountdown((prevCountdown) => {
          if (prevCountdown === 1) {
            setResendLink(false);
            setOperationInProgress(false);
            clearInterval(timer);
            return 45;
          } else {
            return prevCountdown - 1;
          }
        });
      }, 1000);
    }
  };
  return (
    <>
      <div className="LoginArea">
        <h1 className="login_head">Neptune</h1>
        <div className="LoginBox">
          <h5 className="mt-2">OTP Sent!</h5>
          <p className="text-center fs-5">
            An OTP has been sent to your registered email address. Please enter
            the OTP and submit
          </p>
          {/* <p className="text-center fs-5">Enter OTP</p> */}
          <label className="otp-label">Enter OTP</label>
          <div className="">
            <div className="otp_wrapper">
              <OTPInput
                value={otp}
                onChange={setOtp}
                numInputs={4}
                containerStyle={"otp-input-container"}
                inputStyle={"otp-input"}
                renderInput={(props) => <input {...props} />}
                inputType={"tel"}
              />
            </div>
          </div>

          <div className="mt-4 fs-5 text-center">
            {email && countdown < 45 ? (
              <strong>Resend link in 00:{countdown}</strong>
            ) : (
              <strong className="cursor_pointer" onClick={onSubmit}>
                Resend OTP{" "}
              </strong>
            )}
            {/* <strong className='cursor_pointer' onClick={onSubmit}>Resend link </strong> */}
            <p>{email}</p>
          </div>
          <div className="text-center">
            <Link to={"/"}>
              <ArrowLeftIcon sx={{ fontSize: 22 }} />
              Go to login
            </Link>
          </div>
          <div className="form_btn">
            {/* {email && countdown < 45 ? (<button className='login_btn' disabled>
                            link sent 00:{countdown}
                        </button>) : (
                            <button className='login_btn' onClick={onSubmit} >
                                Resend link
                            </button>)
                        } */}
            {otp.length > 3 && (
              <button className="login_btn" onClick={verifyOtp}>
                Submit
              </button>
            )}
          </div>
          {/* <div className="custom_link">
                        <Link to={"/"} className='login_btn'>Go to login</Link>
                    </div> */}
        </div>
      </div>
    </>
  );
};

export default OtpVerify;
